import React, { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import InputGroup from "react-bootstrap/InputGroup";
import { useSortAndFilter } from "../contexts/SortAndFilterContext";
import { Container, StyledFormControl, StyledInputGroupText } from "./styles";
import { messages } from "./messages";

export const InventoryLineSearchBox = (): JSX.Element => {
  const intl = useIntl();
  const sortAndFilterContext = useSortAndFilter();

  const [inventoryLineSearched, setInventoryLineSearched] = useState<string | undefined>(
    sortAndFilterContext.getInventoryLineSearched()
  );

  useEffect(() => {
    if (!sortAndFilterContext.getInventoryLineSearched()) {
      setInventoryLineSearched("");
    }
  }, [sortAndFilterContext]);

  const handleOnChange = useCallback((event: any) => {
    const inventoryLine = event.target.value;
    setInventoryLineSearched(inventoryLine);
    sortAndFilterContext.storeInventoryLineSearched(inventoryLine);
  }, [sortAndFilterContext]);

  return (
    <Container>
      <InputGroup className="mb-4">
        <StyledInputGroupText id="search">
          <FontAwesomeIcon icon={faSearch} />
        </StyledInputGroupText>
        <StyledFormControl
          type="text"
          id="search"
          placeholder={intl.formatMessage(messages.inventoryLine)}
          onChange={handleOnChange}
          value={inventoryLineSearched || ""}
        />
      </InputGroup>
    </Container>
  );
};
